module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-profile"
  }, [_c('h2', [_vm._v("用户信息")]), _c('h3', [_vm._v(_vm._s(_vm.$formatters.user_name(_vm.user)))]), _c('p', [_vm._v("角色: " + _vm._s(_vm.$formatters.user_role(_vm.user)))]), _c('el-tabs', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": null,
      "label": "权限列表"
    }
  }, [_c('div', {
    staticClass: "ui relaxed divided list"
  }, _vm._l((_vm.permissions), function(per) {
    return _c('div', {
      staticClass: "item",
      class: {
        disabled: !_vm.$permission.has(per.key)
      }
    }, [(_vm.$permission.has(per.key)) ? _c('i', {
      staticClass: "large checkmark middle aligned icon themed text"
    }) : _c('i', {
      staticClass: "large minus middle aligned icon"
    }), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v(_vm._s(per.key))]), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(per.name))])])])
  }))])], 1), _c('br'), _c('br'), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f17157c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/UserProfile.vue
// module id = 454
// module chunks = 0